/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_UpdatedInputs */

const zh_profile_updated = /** @type {(inputs: Profile_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人信息已更新`)
};

const en_profile_updated = /** @type {(inputs: Profile_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile updated`)
};

const es_profile_updated = /** @type {(inputs: Profile_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil actualizado`)
};

/**
* | output |
* | --- |
* | "Profile updated" |
*
* @param {Profile_UpdatedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_updated = /** @type {((inputs?: Profile_UpdatedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_UpdatedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_profile_updated(inputs)
	if (locale === "en") return en_profile_updated(inputs)
	return es_profile_updated(inputs)
});